import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import ComoFunciona from "@/pages/ComoFunciona";

export const Route = createFileRoute("/como-funciona")({
  head: () => seoHead({
    title: "Como funciona o cashback solidário | Shopping do Bem",
    description: "Entenda como suas compras nas lojas parceiras geram cashback solidário para a causa que você escolheu, sem pagar nada a mais.",
    path: "/como-funciona",
  }),
  component: ComoFunciona,
});
